import { isLocale, renderedMessages } from "@mesketch/i18n";
import { useEffect } from "react";
import { IntlProvider } from "react-intl";
import { Navigate, useParams } from "react-router";
import { Shell } from "./components/Layout.js";

export function LocaleLayout() {
  const { lang = "" } = useParams();
  const valid = isLocale(lang);

  useEffect(() => {
    if (valid) document.documentElement.lang = lang;
  }, [lang, valid]);

  if (!valid) return <Navigate to="/" replace />;
  return (
    <IntlProvider locale={lang} messages={renderedMessages(lang)}>
      <Shell />
    </IntlProvider>
  );
}
